var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static_page_loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#EF3405","size":"48","width":"4"}}),_c('p',{staticClass:"static_page_loading__text"},[_vm._v(_vm._s(_vm.$t("STATIC_PAGES.loading")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }